// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusCircleFilledSvg from "@ant-design/icons-svg/es/asn/MinusCircleFilled";
import AntdIcon from '../components/AntdIcon';

var MinusCircleFilled = function MinusCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MinusCircleFilledSvg
  }));
};

MinusCircleFilled.displayName = 'MinusCircleFilled';
export default React.forwardRef(MinusCircleFilled);